import Vue from 'vue'
import Router from 'vue-router'
import HomeComponent from '@/components/HomeComponent'
import ProtocolComponent from '@/components/ProtocolComponent';
import DutyComponent from '@/components/DutyComponent';
import BenefistComponent from '@/components/BenefistComponent';
import SupervisorComponent from '@/components/SupervisorComponent';
import PreventComponent from '@/components/PreventComponent';
import DownloadComponent from '@/components/DownloadComponent';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomeComponent',
      component: HomeComponent
    },
    {
      path: '/protocols',
      name: 'ProtocolComponent',
      component: ProtocolComponent
    },
    {
      path: '/aranceles',
      name: 'DutyComponent',
      component: DutyComponent
    },
    {
      path: '/benefists',
      name: 'BenefistComponent',
      component: BenefistComponent
    },
    {
      path: '/supervisors',
      name: 'SupervisorComponent',
      component: SupervisorComponent
    },
    {
      path: '/downloads',
      name: 'DownloadComponent',
      component: DownloadComponent
    },
    {
        path: '/prevent/:post_id',
        component: PreventComponent,
        props: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js